export const ASC = 'asc';
export const DESC = 'desc';
export const order = [ ASC, DESC ];
const classNames = { [ASC]: 'ascending', [DESC]: 'descending' };

export const flip = (current) => current === ASC ? DESC : ASC;
export const orderClass = (by) => classNames[by] || '';
